import '@styles/style.scss'
import '@js/script';

console.log('Main.js підключений');
